import { useEffect } from 'react'
import { COUNCIL_CONTACT_DATA } from '../../../constants/contact-us'
import { usePageState } from '../../context/page-context'
import ContactCard from './contact-card'
import { BodyTextContainer, ContentContainer, Divider, Heading, Link, useTitleChange } from '@msaf/core-react'

export default function ContactUs() {
  useTitleChange('Contact us')
  const { setPageState } = usePageState()

  useEffect(() => {
    setPageState({
      heading: 'Contact us',
    })
    // Reset page state on unmount
    return () => setPageState({})
  }, [setPageState])

  return (
    <ContentContainer>
      <BodyTextContainer>
        <Heading level={2}>Need some help using Wells Aotearoa New Zealand?</Heading>
        <p>
          Try our {<Link path='/help-centre'>Help Centre</Link>} for useful guides to get you going and help you access
          and use the data.
        </p>
      </BodyTextContainer>
      <BodyTextContainer>
        <Divider isFullWidth />
        <Heading level={2}>Found an issue?</Heading>
        <p>
          If you have found an issue with data or need help understanding the data, contact the relevant Regional or
          Unitary council.
        </p>
        <p>
          If something in Wells Aotearoa New Zealand isn't working properly, contact your closest Regional or Unitary
          council from the list below.
        </p>
      </BodyTextContainer>

      {COUNCIL_CONTACT_DATA.map((council) => {
        return <ContactCard key={council.councilName} {...council} />
      })}
    </ContentContainer>
  )
}
